import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Shared style for paper-fibers background
export const paperFibersBgStyle = {
  backgroundImage: "url('/images/layout/paper-fibers.png')",
  backgroundSize: 'auto',
  backgroundBlendMode: 'multiply',
};

export const paperFibersCardStyle = {
  ...paperFibersBgStyle,
  boxShadow: '0 4px 18px 0 rgba(60, 60, 60, 0.10), 0 1.5px 0 0 #e2e2e2 inset',
};